import Icon from '../Icon';
import React from 'react';
import { Text } from '../typography';
import styles from './InspectionTypeBadge.module.scss';
import { useTranslation } from 'react-i18next';
import {
  getTranslationKey,
  keys,
} from '../../utilities/translator/translation_keys';
import { useCurrentUser } from '../../providers/UserProvider';
import {
  defaultAssessmentTypes,
  allTypesOption,
} from '../../constants/strings';
import { customColors } from '../../utilities';

export default function InspectionTypeBadge({
  type,
  border = false,
  weight = 'semiBold',
}) {
  const invalid = { icon: 'close', color: 'black', name: 'Invalid' };
  const { allTemplateTypes } = useCurrentUser();
  const getTypeInfo = () => {
    if (!type) {
      return invalid;
    }
    const t = type === 'VEHICLE' ? 'fleet' : type?.toLowerCase();
    if (t === 'all_types') {
      return allTypesOption;
    }
    return allTemplateTypes[t] || defaultAssessmentTypes[t] || invalid;
  };

  const { icon, color, name, title } = getTypeInfo();
  const { t } = useTranslation();
  return (
    <div className={border ? styles.containerBorder : styles.container}>
      <Icon
        baseClassName="material-icons-outlined"
        style={{ color: customColors[color?.toUpperCase()] || color }}
      >
        {icon}
      </Icon>
      <Text weight={weight} noMargin>
        {type === 'OBSERVATION'
          ? t(keys.common.OBSERVATION_INCIDENT_INTAKE)
          : t(getTranslationKey(name, 'common')) || t(title) || name}
      </Text>
    </div>
  );
}
